import type { DynamicDialogInstance } from 'primevue/dynamicdialogoptions'

export const useDynamicDialogLifecycle = <T extends object>() => {
  const dialogRef = inject<Ref<DynamicDialogInstance>>('dialogRef')
  const dialogData = ref<Partial<T>>({}) as Ref<Partial<T>>
  const dialogDataIsSet = computed(() => Object.keys(dialogData.value || {}).length > 0)

  const closeDialog = () => dialogRef?.value?.close()

  onBeforeMount(() => {
    dialogData.value = dialogRef?.value?.data || {}
  })

  return {
    dialogRef,
    dialogData,
    dialogDataIsSet,
    closeDialog,
  }
}
